import { Component, Input, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxScrollViewModule } from 'devextreme-angular/ui/scroll-view';
import { TranslateModule } from '@ngx-translate/core';
import { CardAuthComponent } from '../../components/library/card-auth/card-auth.component';
import { LanguageSwitcherComponent } from '../../components/library/language-switcher/language-switcher.component';
import { ThemeService } from '../../services/theme.service';

/**
 * Layout shell del flujo de auth: brand panel a la izquierda + form panel a la
 * derecha + card-auth con título/descripción + acciones flotantes (idioma + tema)
 * + legal line al pie. La página hija (sign-in-form, reset-password, etc.) emite
 * SOLO el formulario via `<router-outlet>`; el card chrome lo provee este shell.
 *
 * `titleKey` / `descriptionKey` reciben las CLAVES de traducción (p. ej.
 * `'auth.iniciarSesion'`) — el shell las resuelve internamente con `| translate`.
 * Pasarlas como claves (no como strings ya traducidos) deja la responsabilidad
 * de i18n acá y el padre (`UnauthenticatedContent`) solo mapea ruta → clave.
 */
@Component({
  selector: 'app-single-card',
  templateUrl: './single-card.component.html',
  styleUrls: ['./single-card.component.scss'],
  imports: [
    CommonModule,
    DxScrollViewModule,
    TranslateModule,
    CardAuthComponent,
    LanguageSwitcherComponent,
  ],
})
export class SingleCardComponent {
  /** Clave de traducción del título de la card (`auth.iniciarSesion`, etc.). */
  @Input() titleKey = '';
  /** Clave de traducción del subtítulo. Si está vacía, no se renderiza. */
  @Input() descriptionKey = '';

  year = new Date().getFullYear();

  private themeService = inject(ThemeService);
  isDark = signal<boolean>(this.themeService.currentTheme === 'dark');

  toggleTheme(): void {
    this.themeService.switchTheme();
    this.isDark.set(this.themeService.currentTheme === 'dark');
  }
}
